import type { RouteObject } from 'react-router';
import { ApprovalThresholdsPage } from './pages/ApprovalThresholdsPage';

export const APPROVAL_THRESHOLD_ROUTES: RouteObject[] = [{ path: 'approval-thresholds', element: <ApprovalThresholdsPage /> }];
